import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const MainLogo = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        border: "2px solid " + colors.blueAccent[500], // Outline
        padding: "50px", // Padding inside the box
        borderRadius: "20px", // Optional rounded corners
        margin: "0px 10px 10px 10px",
        width: "100%", // Center the box
      }}
      justifyContent="space-between"
    >
      <Box display="flex" justifyContent="space-between" alignItems="left">
        <Box>
          <Box display={"flex"}>
            <Typography
              variant="h1"
              color={colors.grey[100]}
              fontWeight="bold"
              sx={{ mb: "15px" }}
            >
              WELCOME TO
            </Typography>
            <div className="notranslate">
              <Typography
                variant="h1"
                color={colors.grey[100]}
                fontWeight="bold"
                sx={{ mb: "15px", ml: "10px" }}
              >
                JUSTENANT
              </Typography>
            </div>
          </Box>
          <Typography variant="h4" color={colors.blueAccent[600]}>
            You can control all status of the project using this panel
          </Typography>
        </Box>
        <Box>
          <img
            alt="main-logo"
            src={`../../assets/icons/logo_text.png`}
            style={{
              cursor: "pointer",
              width: "80%",
              height: "auto",
              minWidth: "100px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLogo;
